/**
 * Parses a serialized table field value into rows of column values.
 *
 * Format: rows are separated by `;`, columns within a row are separated by `,`, and every value is
 * wrapped in double quotes. A literal `"` inside a value is escaped as `""` (CSV-style escaping).
 */
export function parseTableFieldValue(raw: string): string[][] {
  if (!raw) {
    return [];
  }

  const rows: string[][] = [];
  let row: string[] = [];
  let value = '';
  let inQuotes = false;

  for (let i = 0; i < raw.length; i++) {
    const char = raw[i];

    if (inQuotes) {
      if (char === '"' && raw[i + 1] === '"') {
        value += '"';
        i++;
      } else if (char === '"') {
        inQuotes = false;
      } else {
        value += char;
      }
      continue;
    }

    if (char === '"') {
      inQuotes = true;
    } else if (char === ',') {
      row.push(value);
      value = '';
    } else if (char === ';') {
      row.push(value);
      rows.push(row);
      row = [];
      value = '';
    } else {
      value += char;
    }
  }

  if (value !== '' || row.length) {
    row.push(value);
    rows.push(row);
  }

  return rows.filter(r => r.some(v => v !== ''));
}
